import { useCallback } from 'react'
import { useDispatch } from 'react-redux'
import {
  addAllListDrops,
  setAllDropsStatusLoading,
} from '../../modules/listDrops/actions'
import { useLazyGetAllDropsQuery } from '../../modules/listDrops/api'

const useFetchAndStoreAllDropsData = () => {
  const dispatch = useDispatch()
  const [fetchAllDrops] = useLazyGetAllDropsQuery()

  const dispatchAllDropsToStore = useCallback(
    async ({
      search,
      limit,
      offset,
      status,
      sort,
    }: {
      search?: string
      limit?: number
      offset?: number
      status?: string
      sort?: string
    }) => {
      try {
        dispatch(setAllDropsStatusLoading(true))

        const { drops, total } = await fetchAllDrops({
          search,
          limit,
          offset,
          status,
          sort,
        }).unwrap()

        dispatch(addAllListDrops(drops, total))
      } catch (error) {
        console.error(error)
      } finally {
        dispatch(setAllDropsStatusLoading(false))
      }
    },
    [dispatch, fetchAllDrops],
  )

  return dispatchAllDropsToStore
}

export default useFetchAndStoreAllDropsData
